import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ConfigRequired } from './ConfigRequired';

export function RequireAuth() {
  const auth = useAuth();
  const location = useLocation();
  if (auth.configMissing) return <ConfigRequired />;
  if (auth.loading) return <div className="full-loader"><span className="loader" />Loading your hub…</div>;
  if (!auth.user) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/hub/login?redirect=${redirect}`} replace />;
  }
  return <Outlet />;
}

export function RequireAdmin() {
  const { roles } = useAuth();
  const allowed = roles.includes('admin') || roles.includes('super_admin');
  if (!allowed) return <Navigate to="/hub" replace />;
  return <Outlet />;
}

export function RedirectAuthenticated() {
  const auth = useAuth();
  if (auth.configMissing) return <ConfigRequired />;
  if (auth.loading) return <div className="full-loader"><span className="loader" />Loading…</div>;
  if (auth.user) return <Navigate to="/hub" replace />;
  return <Outlet />;
}
